import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from '@mui/material';
import {
	AuthBannerWithDate,
	AuthStatusBar,
	HiddenProductInfo,
	ImageCarousel,
	ProductChipGroup,
	ProductInfoBox,
} from 'components';
import RecallInfoBox from 'components/Product/RecallInfoBox';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useProduct, useVerify } from 'stores';
import { MotionWrapper } from 'utils';

const Product = () => {
	const product = useProduct();
	const verify = useVerify();
	const { t, i18n } = useTranslation();
	const [openVerifyMessage, setOpenVerifyMessage] = useState(false);

	const message = verify?.message;
	const verifyCode = verify?.code;
	const status = verify?.status;

	const CloseVeriftMessage = () => {
		setOpenVerifyMessage(false);
	};

	useEffect(() => {
		if (
			['msg_code_receive_gift_successful'].indexOf(verifyCode) !== -1 ||
			(status !== 'success' &&
				message &&
				message.content.trim().length !== 0)
		) {
			setOpenVerifyMessage(true);
		}
	}, [verify]);

	if (!product) {
		// 	Case handled in Protected route, return to Homepage if no product exist.
		return <></>;
	}

	const imageList = product.imgs;
	//const productName = product.name[i18n.resolvedLanguage];
	const productName = product.productBatchName
		? product.productBatchName[i18n.resolvedLanguage]
		: undefined;
	const recallInfo = product.recallInfo;
	const batchNumber = product.batchNumber ? product.batchNumber : undefined;
	const hiddenProductInfoList = product.hiddenProductInfoList;
	const verifyStatus = verify ? verify.verifyStatus : null;
	const currentReqUAID = product.currentReqUAID;
	const uaidType = product.uaidType;
	//const qrCodeType = product.qrCodeType;
	//authenticatioId and challengeCode for authentication code and authorization code verification
	const authenticationId = product.authenticationId;
	const challengeCode = product.challengeCode;
	const scanCount = verify ? verify.totalScanCount : undefined;
	const firstVerifySDatetimeInt = verify
		? verify.firstVerifySDatetimeInt
		: undefined;
	//console.log("coupons -> "+ JSON.stringify(hiddenProductInfoList[0]))

	return (
		<>
			<MotionWrapper pb={2} spacing={0}>
				<Stack spacing={1} overflow="scroll" pb={1}>
					<RecallInfoBox recallInfo={recallInfo} />
					<ImageCarousel imgs={imageList} verifyCode={verifyCode} />
					<HiddenProductInfo />
					<Typography
						pl={2}
						pr={2}
						fontSize="20px"
						fontWeight="700"
						color="defaultText.main"
					>
						{productName}
					</Typography>
					<AuthBannerWithDate />
					<ProductChipGroup
						currentReqUAID={currentReqUAID}
						batchNumber={batchNumber}
						uaidType={uaidType}
						status={status}
						scanCount={scanCount}
						firstVerifySDatetimeInt={firstVerifySDatetimeInt}
						hiddenProductInfoList={hiddenProductInfoList}
					/>
					<ProductInfoBox />
				</Stack>
				<Stack>
					<AuthStatusBar
						currentReqUAID={currentReqUAID}
						uaidType={uaidType}
						status={status}
						authenticationId={authenticationId}
						challengeCode={challengeCode}
						verifyStatus={verifyStatus}
						verifyCode={verifyCode}
						productName={productName}
					/>
				</Stack>
			</MotionWrapper>
			<Dialog
				open={openVerifyMessage}
				onClose={CloseVeriftMessage}
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="alert-dialog-title"></DialogTitle>
				<DialogContent>
					{!status ? (
						<Typography
							style={{
								color: 'primary.main',
								fontSize: 'medium',
								fontWeight: 'bold',
							}}
						>
							{t('product.authTip')}
						</Typography>
					) : verifyCode === 'msg_code_hidden_authed_fail' ? (
						<>
							<Typography
								style={{
									color: 'red',
									fontSize: 'medium',
									fontWeight: 'bold',
								}}
							>
								{'WARNING!'}
							</Typography>
							<Typography
								style={{
									color: 'red',
									fontSize: 'small',
									fontWeight: 'bold',
									paddingBottom: '20px',
								}}
							>
								{`This product may be counterfeit as the code has been checked for ${scanCount} times. The first scan is ${new Date(
									firstVerifySDatetimeInt -
										new Date().getTimezoneOffset() * 60000
								)
									.toISOString()
									.replace(/T/, ' ')
									.replace(/\..+/, '')}.`}
							</Typography>
							<Typography
								style={{
									color: 'primary.main',
									fontSize: 'small',
									fontWeight: 'bold',
								}}
							>
								{'Please leave a message via '}
								<Link
									to={
										'https://www.orienticaperfumes.com/pages/contact-us'
									}
								>
									{'Contact Us'}
								</Link>
								{
									' and we will get back to you as soon as possible.'
								}
							</Typography>
						</>
					) : (
						<Typography
							style={{
								color: 'primary.main',
								fontSize: 'medium',
								fontWeight: 'bold',
							}}
						>
							{message ? message.content : null}
						</Typography>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={CloseVeriftMessage}>
						{t('product.noted')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default Product;
